/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SpinnerComponent } from '../../shared/components/spinner/spinner.component';

@Injectable()
export class NotificationService {

  errorHandler = (error: Error) => this.open(`Error received from API: ${error.message}`);

  constructor(
    private notification: MatSnackBar,
    private spinnerDialog: MatDialog) {
  }

  public open(msg: string, type = 'Close', options = { duration: 6000 }): void {
    const development = true;
    if (development) {
      console.log(msg);
    }
    this.notification.open(msg, type, options);
  }

  public loading() {
    return this.spinner('Loading...');
  }

  public spinner(msg: string, options = {}) {
    return this.spinnerDialog.open(SpinnerComponent, {
      height: msg.length < 40 ? '120px' : '200px',
      width: '250px',
      data: {
        title: msg
      },
      ...options,
    });
  }
}
